<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import FormButton from '../Atoms/FormButton.vue';
import IconBase from '../icon/IconBase.vue';
import IconGrid from '../icon/IconGrid.vue';
import IconList from '../icon/IconList.vue';

const store = useStore()

const shouldShowCompactModeStreams = computed(() => store.getters['Ui/shouldShowCompactModeStreams'])

const toggleCompactMode = (value) => {
	store.dispatch('Ui/setCompactModeStreams', value);
}
const base = 'h-7 w-7 flex items-center justify-center rounded transition-colors duration-150'
const active = 'bg-surface-5 text-white shadow-sm'
const inactive = 'bg-transparent text-surface-7 hover:text-surface-9 hover:bg-surface-4'
</script>

<template>
  <ul class="view-mode-switcher flex items-center gap-0.5 bg-surface-3 rounded-md p-0.5">
    <li>
      <FormButton aria-label="Grid view" :disabled="!shouldShowCompactModeStreams" isIcon @click="toggleCompactMode(false)" :customClasses="[base, !shouldShowCompactModeStreams ? active : inactive]">
        <icon-base>
          <icon-grid />
        </icon-base>
      </FormButton>
    </li>
    <li>
      <FormButton aria-label="List view" :disabled="shouldShowCompactModeStreams" isIcon @click="toggleCompactMode(true)" :customClasses="[base, shouldShowCompactModeStreams ? active : inactive]">
        <icon-base>
          <icon-list />
        </icon-base>
      </FormButton>
    </li>
  </ul>
</template>

<style scoped>
</style>
